module.exports = __webpack_public_path__ + "static/favicon-96x96-425ea5890b2a5b4229ba18ec8a5e7584.png";